import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoActivosComponent } from './activos/listado-activos/listado-activos.component';
import { CrearEditarActivoComponent } from './activos/crear-editar-activo/crear-editar-activo.component';
import { MapaActivosComponent } from './mapa-activos/mapa-activos.component';
import { DetallesActivoComponent } from './activos/detalles-activo/detalles-activo.component';
import { ListadoGruposComponent } from '../../standalone/grupos/listado-grupos/listado-grupos.component';
import { ListadoUbicacionesComponent } from '../../standalone/ubicaciones/listado-ubicaciones/listado-ubicaciones.component';
import { CrearEditarUbicacionComponent } from '../../standalone/ubicaciones/crear-editar-ubicacion/crear-editar-ubicacion.component';

const routes: Routes = [
  { path: '', redirectTo: 'mapa', pathMatch: 'full' },
  {
    path: 'activos',
    title: 'Activos',
    component: ListadoActivosComponent,
    canActivate: [],
  },
  // Activos
  {
    path: 'activos/crear',
    title: 'Nuevo activo',
    component: CrearEditarActivoComponent,
    canActivate: [],
  },
  {
    path: 'activos/editar/:id',
    title: 'Editar activo',
    component: CrearEditarActivoComponent,
    canActivate: [],
  },
  {
    path: 'activos/detalles/:id',
    title: 'Activo',
    component: DetallesActivoComponent,
    canActivate: [],
  },
  // Mapa
  {
    path: 'mapa',
    title: 'Mapa de activos',
    component: MapaActivosComponent,
    canActivate: [],
  },
  // Ubicaciones
  {
    path: 'ubicaciones/:categoria',
    title: 'Ubicaciones',
    component: ListadoUbicacionesComponent,
    canActivate: [],
  },
  {
    path: 'ubicaciones/:categoria/crear',
    title: 'Nueva ubicación',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  {
    path: 'ubicaciones/:categoria/editar/:id',
    title: 'Editar ubicación',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  // Agrupaciones
  {
    path: 'grupos/:categoria',
    title: 'Agrupaciones',
    component: ListadoGruposComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActivosRoutingModule {}
